import EulerView, { StyleProps } from '@euler/components/layout/View';
import { memo } from 'react';
import { ViewProps } from 'react-native-svg/lib/typescript/fabric/utils';

export const HStack = memo(
  (props: Omit<ViewProps & StyleProps, 'flexDirection'>) => {
    return (
      <EulerView
        justifyContent="space-between"
        alignItems="center"
        {...props}
        flexDirection="row"
      />
    );
  },
);
